import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PageH1 from "@components/seo/PageH1";
import FormStylingJS from "@widgets/form/FormStylingJS";
const SubscribePageHeader = (props) => {
    const { title, description } = props;
    FormStylingJS();
    return ((!!title || !!description) && (_jsxs("div", { className: "rich-text__wrapper py-4", children: [!!title && (_jsx(PageH1, { fallbackElement: "h2", className: "rich-text__h2", children: title })), !!description && _jsx("div", { className: "rich-text__wrapper", dangerouslySetInnerHTML: { __html: description } })] })));
};
export default SubscribePageHeader;
